import React, { useEffect, useRef } from 'react';
import { array, bool, number, object } from 'prop-types';
import classnames from 'classnames';
import './SurveyMigrations.scss';
import { withRouter } from 'react-router';

function SurveyMigrations(props) {
  let migrationsRef = useRef(null);
  let selectedMigrationRef = useRef(null);

  useEffect(() => {
    if (migrationsRef?.current && selectedMigrationRef?.current) {
      migrationsRef.current.scrollTop = selectedMigrationRef.current.offsetTop - migrationsRef.current.offsetTop;
    }
  }, [selectedMigrationRef]);

  function selectSurveyMigration(migration) {
    props.history.push(`/market-analysis/data-cut-migration/${migration.sessionPk}`);
  }

  function renderSurveyMigrations() {
    return props.surveyMigrations.map(migration => {
      const isCurrentMigration = props.currentMigrationId === migration.sessionPk;
      return (
        <div
          className={classnames('survey-migration', {
            'survey-migration__selected': isCurrentMigration
          })}
          key={migration.sessionPk}
          onClick={selectSurveyMigration.bind(this, migration)}
          ref={isCurrentMigration ? selectedMigrationRef : undefined}
        >
          <div className="survey-migration__cell">
            <div className="survey-migration__main-line">
              <div className="pxl-text-xsmall survey-migration__codes">
                {migration.curSurveyCode} <i className="icon-right" /> {migration.newSurveyCode}
              </div>
              <div className="pxl-text-small survey-migration__title" title={migration.curSurveyTitle}>
                {migration.curSurveyTitle}
              </div>
            </div>
          </div>
        </div>
      );
    });
  }

  return (
    <div className="survey-migrations__panel" ref={migrationsRef}>
      {renderSurveyMigrations()}
    </div>
  );
}

SurveyMigrations.propTypes = {
  surveyMigrations: array,
  page: number,
  offset: number,
  currentMigrationId: number,
  history: object
};

export default withRouter(SurveyMigrations);
